import styled from "styled-components";

export const Layout = styled.div`

`;
export const Body = styled.div`
  position: relative;
`;
export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  
`;
export const Card = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid rgb(255, 229, 143);
  background: rgba(255, 229, 143, 0.2);
  border-radius: 8px;
  padding: 14px 20px 20px;
`;
export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #000;
  height: 40px;
  line-height: 40px;
  //margin-left: 44px;
  
  text-align: left;
  //width: 300px;
  //margin: auto;
  //font-weight: bold;
  flex: 1;
`;

export const AmountLabel = styled.span`
  display: inline-block;
`;
export const Amount = styled.em`
  margin-left: 14px;
  color: #f84600;
  font-size: 30px;
  font-weight: 700;
  font-style: normal;
  margin-right: 12px;
`;

export const Extra = styled.div`
  //position: absolute;
  right: 10px;
  font-size: 14px;
  top: 4px;
 
`;

export const MeTransferButton = styled.button`
  color: #911414;
  font-weight: bold;
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer;
  &:active {
    background: none;
  }
`;